import CondicaoModel from "@/models/paciente/condicaoModel";

import { iServiceCached } from "../base/iServiceCached";

class CondicaoService extends iServiceCached<CondicaoModel> {
    constructor() {
        super("Condicao");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
            franquiaId: p.franquiaId,
        }));
    }
}

export default new CondicaoService();
